function _(a,n,s){a(164),s.bk_canvas="bk-canvas",s.bk_canvas_map="bk-canvas-map",s.bk_canvas_overlays="bk-canvas-overlays",s.bk_canvas_events="bk-canvas-events"}
//# sourceMappingURL=canvas.min.js.map